import ObjCategoriesThree from './ObjCategoriesThree-2'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { BannerTwo } from "../../components/BannerTwo/BannerTwo";
import { SaleBanner } from "../../components/SaleBanner/SaleBanner";

export const CategoriesThree2 = () => {
  return (
    <section className="Section 7">
        <div className="categories-three2">
            <div className="categories-three__content2">
                <div className='box' id='c7-1'>
                    <div className="box__content">
                        <BannerTwo />
                    </div>
                </div>
                <div className='box' id='c7-2'>
                    <div className="box__content">
                        <SaleBanner />
                    </div>
                </div>
                   {/*  {
                        ObjCategoriesThree.map((id, index) =>{
                            return (
                                <div key={index} className='box' id={id.class}>
                                    <div className="box__content">
                                        <div className="btn-white">
                                            <a href={id.url} target='_parent'>{id.name}</a>
                                            <p>{id.text}</p>
                                        </div>
                                        
                                    </div>
                                </div>
                            )
                        })
                    } */}
            </div>
        </div>
    </section>
  )
}

export default CategoriesThree2